



























































































import mixins from "vue-typed-mixins";
import { GeneralMixin } from "@/mixins/general-mixin";
import Snackbar from "@/components/general/snackbar.vue";
import FooterGeneralNoBg from "@/components/general/footer-general-no-bg.vue";

export default mixins(GeneralMixin).extend({
  name: "Recover",
  components: {
    Snackbar,
    FooterGeneralNoBg,
  },

  data() {
    return {
      email: "",
      loading: false,
      rules: {
        required: (value: any) => !!value || "Obrigatório!",
        email: (value: any) =>
          !this.isEmailValid(value)
            ? (this.$t(`errors.${this.error_message.invalid_email}`) as string)
            : true,
      },
    };
  },
  methods: {
    async postRecoveryForm(): Promise<any> {
      await this.$store.dispatch("toggleSnackbar", null);
      if (this.form.validate()) {
        this.loading = true;
        const data = { email: this.email };
        const resp = await this.$store.dispatch("resetLoginPassword", data);
        this.loading = false;
        if (resp.success === true) {
          return this.$store.dispatch("toggleSnackbar", {
            show: true,
            message: this.$t(`success.${this.success_message.password_reset}`),
            color: "green",
          });
        } else {
          const formWithNoExistingEmail =
            "Não existe conta associada ao e-mail indicado ou a mesma foi desativada!";
          if (resp.message === formWithNoExistingEmail) {
            return this.$store.dispatch("toggleSnackbar", {
              show: true,
              message: this.$t(
                `errors.${this.error_message.form_with_no_existing_email}`
              ),
            });
          }

          return this.$store.dispatch("toggleSnackbar", {
            show: true,
            message: this.$t(`errors.${this.error_message.generic_error}`),
          });
        }
      } else {
        return this.$store.dispatch("toggleSnackbar", {
          show: true,
          message: this.$t(`errors.${this.error_message.form_has_error}`),
        });
      }
    },
  },
});
